module.exports = __webpack_public_path__ + "img/questionnaire.7ef4d7dc.png";